import React, { useEffect } from 'react';
import { AlertBox, AlertBoxDismissButton } from '@vp/swan';
import { __ } from '@99designs/i18n';

const TIMEOUT_MS = 4000;

export interface DraftBriefDeletedToastProps {
    briefTitle: string;
    removeFromQueue: (title: string) => void;

    isError?: boolean;
}

export default function DraftBriefToast(props: DraftBriefDeletedToastProps) {
    const { briefTitle, removeFromQueue, isError } = props;

    const deletedTitle = __('{{title}} was deleted', {
        _context: "The alert toast's message when a draft brief is successfully deleted.",
        title: briefTitle,
    });
    const errorTitle = __("Sorry, couldn't delete draft. Please try again", {
        _context: "The alert toast's message when there is an error deleting a draft brief.",
    });

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            removeFromQueue(briefTitle);
        }, TIMEOUT_MS);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [briefTitle, removeFromQueue]);

    return (
        <AlertBox mt={5} toast skin={isError ? 'error' : 'success'}>
            {isError ? errorTitle : deletedTitle}
            <AlertBoxDismissButton
                onClick={() => removeFromQueue(briefTitle)}
                accessibleText={__('Close')}
            />
        </AlertBox>
    );
}
